/**
 * Created by pmnia on 7/1/15.
 */
//layout.require.js
require('./layout.module.js');
//require('./ht-sidebar.directive.js');
//require('./ht-top-nav.directive.js');
require('./layout.controller.js');
require('./shell.controller.js');
//require('./sidebar.controller.js');
require('./app.controller.js');

require('./layout.route.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/layout.require.js
 ** module id = 218
 ** module chunks = 0
 **/